var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _circle2, _path11, _path12, _path13, _circle3, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadDisposition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#30D8A7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.783 12.1172C18.3624 12.1172 18.0234 12.4895 18.0234 12.9529V27.0496C18.0234 27.5121 18.3624 27.8853 18.783 27.8853H29.6266C30.0472 27.8853 30.3862 27.5121 30.3862 27.0496V12.9529C30.3862 12.4895 30.0472 12.1172 29.6266 12.1172H18.783ZM18.6308 12.8096H29.7724V27.1849H18.6308V12.8096Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2329 14.2031H24.9219V15.9909H28.2329V14.2031Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2173 14.2031H20.9062V15.9909H24.2173V14.2031Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2329 16.6328H24.9219V18.4206H28.2329V16.6328Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2173 16.6328H20.9062V18.4206H24.2173V16.6328Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2329 19.125H24.9219V20.9128H28.2329V19.125Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2173 19.125H20.9062V20.9128H24.2173V19.125Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2329 21.6172H24.9219V23.405H28.2329V21.6172Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2173 21.6172H20.9062V23.405H24.2173V21.6172Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2329 24.0781H24.9219V25.8659H28.2329V24.0781Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2173 24.0781H20.9062V25.8659H24.2173V24.0781Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4297 29.8047L9.61719 27.8438V12.1631L21.4297 10.2031V29.8047ZM16.1982 16.6279L15.2285 18.8701C15.1686 19.0327 15.1471 19.1152 15.1533 19.2207C15.1397 19.13 15.1126 18.9955 15.0537 18.8701L14.2354 16.7441L12.8545 16.8262L14.2871 20.0674L12.6953 23.2988L14.0723 23.3809L15.0537 21.1045C15.0945 20.9936 15.0974 20.9432 15.1045 20.8818C15.1198 20.968 15.1046 20.9922 15.1807 21.168L16.1562 23.5049L17.7617 23.6006L15.9482 20.0195C16.5047 18.8479 17.0845 17.6874 17.6875 16.5391L16.1982 16.6279Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#30D8A7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2656 13.9474C11.2656 13.4285 11.6863 13.0078 12.2052 13.0078H27.7961C28.315 13.0078 28.7357 13.4285 28.7357 13.9474C28.7357 14.4663 28.315 14.887 27.7961 14.887H12.2052C11.6863 14.887 11.2656 14.4663 11.2656 13.9474Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2656 20.2208C11.2656 19.7019 11.6863 19.2812 12.2052 19.2812H23.1507C23.6696 19.2812 24.0903 19.7019 24.0903 20.2208C24.0903 20.7398 23.6696 21.1604 23.1507 21.1604H12.2052C11.6863 21.1604 11.2656 20.7398 11.2656 20.2208Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2656 26.049C11.2656 25.53 11.6863 25.1094 12.2052 25.1094H20.0035C20.5224 25.1094 20.9431 25.53 20.9431 26.049C20.9431 26.5679 20.5224 26.9886 20.0035 26.9886H12.2052C11.6863 26.9886 11.2656 26.5679 11.2656 26.049Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.6776,
    cy: 25.5448,
    r: 6.43546,
    fill: "white",
    stroke: "#30D8A7",
    strokeWidth: 0.890529
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1172 25.5484C24.1172 25.1549 24.4362 24.8359 24.8296 24.8359H30.529C30.9225 24.8359 31.2414 25.1549 31.2414 25.5484C31.2414 25.9418 30.9225 26.2608 30.529 26.2608H24.8296C24.4361 26.2608 24.1172 25.9418 24.1172 25.5484Z",
    fill: "#30D8A7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6812 29.1094C27.2877 29.1094 26.9688 28.7904 26.9688 28.397V22.6976C26.9688 22.3041 27.2877 21.9851 27.6812 21.9851C28.0746 21.9851 28.3936 22.3041 28.3936 22.6976V28.397C28.3936 28.7904 28.0746 29.1094 27.6812 29.1094Z",
    fill: "#30D8A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadDisposition);
export default __webpack_public_path__ + "static/media/Lead Disposition.53851f0ac7c4f50f1d56792a64b7f6a2.svg";
export { ForwardRef as ReactComponent };